/* Nimra Atelier — custom storefront behaviour */
(function () {
  'use strict';

  function pathOf(anchor) {
    var href = anchor.getAttribute('href');
    if (!href) return '';
    try {
      return new URL(href, window.location.origin).pathname.replace(/\/+$/, '');
    } catch (err) {
      return '';
    }
  }

  function endsWith(path, suffix) {
    return path.slice(-suffix.length) === suffix;
  }

  function findMenuToggle() {
    return (
      document.querySelector('header-drawer summary') ||
      document.querySelector('summary.header__icon--menu') ||
      document.querySelector('.header__icon--menu')
    );
  }

  /* "Jewelry" opens the slide-out category menu instead of navigating */
  function onJewelryClick(event) {
    var toggle = findMenuToggle();
    if (!toggle) return; // no drawer on this layout — let the link navigate
    event.preventDefault();
    event.stopPropagation();
    toggle.click();
    if (typeof toggle.focus === 'function') toggle.focus();
  }

  /* "Home page" collection card goes to the actual homepage */
  function onFrontpageClick(event) {
    event.preventDefault();
    event.stopPropagation();
    window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function wire() {
    var anchors = document.querySelectorAll('a[href*="/collections/"]');

    Array.prototype.forEach.call(anchors, function (anchor) {
      if (anchor.dataset.nimraWired === 'true') return;
      var path = pathOf(anchor);
      if (!path) return;

      if (endsWith(path, '/collections/jewelry')) {
        anchor.dataset.nimraWired = 'true';
        anchor.addEventListener('click', onJewelryClick);
      } else if (endsWith(path, '/collections/frontpage')) {
        anchor.dataset.nimraWired = 'true';
        anchor.addEventListener('click', onFrontpageClick);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }

  document.addEventListener('shopify:section:load', wire);
})();
